// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Olli Powroznik, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : slider widget implementation
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Icon, Button, Transition} from 'semantic-ui-react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {get, size, mapItems, flatten, delay} from 'ldash'
import {useSelector, useActions, useState, useImagePreload, useInterval} from 'uix/hooks'
import log from 'uix/logging'

// ---Local imports
import HStyles from './heroSlider.scss'
import {wcUrl} from './utils'

// ---Globals

let DATA = [
  {
    header: 'Die Kanone',
    pageId: 135648,
    width: 304,
    height: 447,
    description:
      'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
    category: 'Fundstücke',
    crop: '103%',
  },
  {
    header: 'Die Karte',
    pageId: 110795,
    width: 304,
    height: 193,
    description:
      'Mit der aktuellen Version 1906ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard derr Text Encoding Initiative (TEI) zu erschließen. Sie finden hier ausgewählte Beispiele, die die Möglichkeiten der Erschließung verdeutlichen. Machen Sie Ihre Bestände sichtbar!',
    category: 'Fundstücke',
    crop: '106%',
  },
  {
    header: 'Die Karte',
    pageId: 432785,
    width: 300,
    height: 475,
    description:
      'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
    category: 'Fundstücke',
    crop: '116%',
  },
  {
    header: 'Die Karte',
    pageId: 440859,
    width: 300,
    height: 475,
    description:
      'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
    category: 'Fundstücke',
    crop: '110%',
  },
  {
    header: 'Die Karte',
    pageId: 379996,
    width: 300,
    height: 475,
    description:
      'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
    category: 'Fundstücke',
    crop: '116%',
  },
  {
    header: 'Die Karte',
    pageId: 116008,
    width: 300,
    height: 428,
    description:
      'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
    category: 'Fundstücke',
    crop: '116%',
  },
]

let SliderBody = ({pageId, src, category, width, height, header, description, crop}) => {
  let apiurl = useSelector(Sel.apiurl)
  let go = useActions(Actions.go)

  let maxHeight = 300
  let maxWidth = 450

  if (width > height) {
    height = Math.round((height * maxWidth) / width)
    width = maxWidth
  } else {
    width = Math.round((width * maxHeight) / height)
    height = maxHeight
  }

  let url = src ? apiurl.href(src) : wcUrl(apiurl, 1000, pageId)
  let cssImgUrl = `url(${url})`
  const sliderBackground = {
    backgroundImage: cssImgUrl,
  }

  const pageBackground = {
    backgroundImage: cssImgUrl,
    width: width,
    height: height,
    backgroundSize: crop,
  }

  return (
    <div key={pageId}>
      <div className={HStyles.overlayContainer}>
        <div className={HStyles.contentContainer}>
          <div
            onClick={() => go({tabname: 'viewer', id: pageId})}
            className={HStyles.page}
            style={pageBackground}
          />

          <div className={HStyles.textArea}>
            <div className={HStyles.category}>{category}</div>
            <div className={HStyles.title}>{header}</div>
            <div className={HStyles.description}>{description}</div>
            <Button onClick={() => goToPage()} content="mehr erfahren" />
          </div>
        </div>
      </div>
      <div className={HStyles.imgBackground} style={sliderBackground}></div>
    </div>
  )
}

export const HeaderSliderProto = ({data = DATA, auto = true}) => {
  /* slider component
  :param auto: switch to next slide after some duration
  :type auto: false/true or custom integer for delay in ms
  */

  let apiurl = useSelector(Sel.apiurl)
  let [index, setIndex] = useState(0)
  let [hover, setHover] = useState(false)

  let currentIndex = Math.abs(index % data.length)
  let prevIndex = Math.abs((index + data.length - 1) % data.length)
  let nextIndex = Math.abs((index + 1) % data.length)

  // reset delay on currentIndex change or hover state change
  // delay of null stops timer
  let delay = auto ? auto : null
  if (delay === true) {
    delay = 10000 // 10 sec default
  }
  useInterval(() => setIndex(nextIndex), delay, currentIndex, hover)
  let pagePreload = []
  if (data.length > 0) {
    if (!data[currentIndex].src) {
      pagePreload = [
        wcUrl(apiurl, 1000, data[prevIndex].pageId),
        wcUrl(apiurl, 304, data[prevIndex].pageId),
        wcUrl(apiurl, 1000, data[nextIndex].pageId),
        wcUrl(apiurl, 304, data[nextIndex].pageId),
      ]
    } else {
      // direct src values given
      pagePreload = [apiurl.href(data[prevIndex].src), apiurl.href(data[nextIndex].src)]
    }
  }

  const loaded = useImagePreload(pagePreload)

  const nextSlide = () => setIndex(nextIndex)
  const prevSlide = () => setIndex(prevIndex)
  const jumpToSlide = pageIndex => setIndex(pageIndex)

  const indicator = data.map((e, pageIndex) => {
    if (pageIndex == currentIndex) {
      return (
        <Icon
          color="black"
          key={pageIndex}
          onClick={() => jumpToSlide(pageIndex)}
          link={true}
          id={HStyles.activeIndicator}
          name="circle outline"
        />
      )
    }
    {
      return (
        <Icon
          color="black"
          key={pageIndex}
          onClick={() => jumpToSlide(pageIndex)}
          size="small"
          link={true}
          name="circle"
        />
      )
    }
  })

  // ///Swipe Funktionalität from react-touch
  // <Swipeable onSwipeLeft={nextSlide} onSwipeRight={prevSlide}>
  // </Swipeable>

  return (
    <div>
      <div
        onMouseLeave={() => setHover(false)}
        onMouseEnter={() => setHover(true)}
        className={HStyles.sliderContainer}
      >
        <Transition visible={hover} animation="fade left" duration={500}>
          <Icon
            id={HStyles.prev}
            size="big"
            color="black"
            name="angle left"
            link={true}
            onClick={prevSlide}
          />
        </Transition>
        <Transition visible={hover} animation="fade right" duration={500}>
          <Icon
            id={HStyles.next}
            size="big"
            color="black"
            name="angle right"
            link={true}
            onClick={nextSlide}
          />
        </Transition>
        <div className={HStyles.indicatorContainer}>{indicator}</div>
        {data.length > 0 && <SliderBody {...data[currentIndex]} />}
      </div>
    </div>
  )
}
